module.exports = __webpack_public_path__ + "static/media/vnpplus_banner_landing.0c84ce6d.png";